import "./ContainedLoader.scss";
import PropTypes from "prop-types";

const ContainedLoader = ({ children, className }) => {
    return (
        <section className={`contained-loader ${className || ""}`}>
            <output className="spinner-border"></output>
            {children}
        </section>
    );
};

ContainedLoader.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

export default ContainedLoader;